import { render, staticRenderFns } from "./fail.vue?vue&type=template&id=04bd7bff&scoped=true&"
import script from "./fail.vue?vue&type=script&lang=js&"
export * from "./fail.vue?vue&type=script&lang=js&"
import style0 from "./fail.vue?vue&type=style&index=0&id=04bd7bff&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bd7bff",
  null
  
)

export default component.exports